import { Controller } from '../utils/controller';

export default class extends Controller {
  static outlets = ['accordions'];

  declare readonly accordionsOutlets;

  collapseAll() {
    this.accordionsOutlets.forEach((accordion) => {
      accordion.collapse();
    });
  }

  collapseSiblingAccordions(event) {
    this.accordionsOutlets.forEach((accordion) => {
      if (!accordion.element.contains(event.currentTarget)) {
        accordion.collapse();
      }
    });
  }
}
